import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeof',
  standalone: true,
})
export class TypeofPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: unknown, ...args: unknown[]): unknown {
    let rv: string = typeof value;
    if (rv === 'number' && Number.isNaN(value)) {
      rv = 'nan';
    }

    return rv;
  }
}
